export default __webpack_public_path__ + "static/media/Intro2.f23f08ab.mp3";